"use client";

import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { PropsWithChildren } from "react";
import EnableSellingTooltip from "./EnableSellingTooltip";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props extends PropsWithChildren {
  showChildren: boolean;
  smallText?: boolean;
  containerBackground?: string;
}

const ProtectedContent: React.FC<Props> = ({
  children,
  showChildren,
  smallText,
  containerBackground,
}) => {
  const router = useRouter();
  const t = useTranslation();
  if (showChildren) return children;

  const handleClick = () => {
    router.push(PagesPaths.signin);
  };

  return (
    <EnableSellingTooltip enableSelling={showChildren}>
      <div
        style={{
          position: "relative",
          cursor: "pointer",
          width: "100%",
        }}
        onClick={handleClick}
      >
        <div
          style={{
            filter: "blur(4px)",
            pointerEvents: "none",
            userSelect: "none",
            backgroundColor: containerBackground,
          }}
        >
          {children}
        </div>
        <div
          className={`protected-content-overlay ${smallText ? "mobile" : ""}`}
        >
          {t.sign_in_first}
        </div>
      </div>
    </EnableSellingTooltip>
  );
};

export default ProtectedContent;
